import { useState, FunctionComponent, MouseEvent, KeyboardEvent } from 'react'
import { Info } from 'lucide-react'
import { styled } from '@mui/material/styles'
import MuiPopover from '@mui/material/Popover'
import { ENTER_KEY, ESCAPE_KEY } from 'constants/key-codes'
import TileInfoPopoverContentContainer from 'redux/containers/components/tiled-menu/TileInfoPopoverContentContainer'

const Popover = styled(MuiPopover)({ '& .MuiPopover-paper': { borderRadius: 0 } })

interface TileInfoPopoverProps {
  title: string
  getUrl: any
  nodes: any
  sectionId: string
  contentOverride: boolean
}

const TileInfoPopover: FunctionComponent<TileInfoPopoverProps> = ({ title, getUrl, nodes, sectionId, contentOverride }) => {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null)

  return (
    <>
      <span
        className='ml2 w8 hs8 bg-transparent hover-bg-ghost-white focus-bg-ghost-white flex justify-center items-center br2 pointer outline-0'
        tabIndex={0}
        onClick={(e) => {
          e.preventDefault()
          setAnchorEl(e.currentTarget)
        }}
        onKeyDown={(e: KeyboardEvent) => {
          if (anchorEl === null && e.keyCode === ENTER_KEY) {
            setAnchorEl(e.currentTarget)
          }
          if (anchorEl !== null && e.keyCode === ESCAPE_KEY) {
            setAnchorEl(null)
          }
        }}
        onMouseEnter={(e: MouseEvent) => {
          e.preventDefault()
          setAnchorEl(e.currentTarget)
        }}
        data-testid='tile-info-icon'
      >
        <Info strokeWidth={1.5} size={24} className='dark-cerulean w7 hs7' />
      </span>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
        transformOrigin={{ vertical: 'center', horizontal: 'center' }}
        transitionDuration={{ enter: 300, exit: 300 }}
        disableRestoreFocus
      >
        <div onMouseLeave={() => setAnchorEl(null)}>
          <TileInfoPopoverContentContainer
            {...{ title, getUrl, sectionId, nodes, contentOverride }}
            remove={() => setAnchorEl(null)}
          />
        </div>
      </Popover>
    </>
  )
}

export default TileInfoPopover
